import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ServiceWorkerService } from '../../../core/services/serviceworker.service';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { SwUpdate } from '@angular/service-worker';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-update-notification',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './update-notification.component.html',
  styleUrls: ['./update-notification.component.less']
})
export class UpdateNotificationComponent implements OnInit, OnDestroy {
  showUpdateNotification = false;
  private destroy$ = new Subject<void>();
  countdown = 20; // seconds before auto-update

  constructor(
    private messageService: MessageService,
    private serviceWorkerService: ServiceWorkerService,
    private swUpdate: SwUpdate
  ) { }

  ngOnInit(): void {
    // Listen for update messages from the message service
    this.messageService.messageObserver
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        if (Array.isArray(message)) {
          const updateMessage = message.find(m => m.key === 'update-available');
          if (updateMessage) {
            this.showUpdateNotification = true;
            this.startCountdown();
          }
        } else if (message && message.key === 'update-available') {
          this.showUpdateNotification = true;
          this.startCountdown();
        }
      });

    // Listen for custom service worker update events
    window.addEventListener('sw-update-available', (event: Event) => {
      const customEvent = event as CustomEvent;
      console.log('🔄 Update notification received:', customEvent.detail);
      this.showUpdateNotification = true;
    });
  }

  coundDownSub: Subscription;
  private startCountdown(): void {
    this.countdown = 20; // show 5 seconds countdown
    const countdown$ = interval(1000).pipe(takeUntil(this.destroy$));

    this.coundDownSub = countdown$.subscribe(() => {
      if (this.countdown > 1) {
        this.countdown--;
      } else {
        this.coundDownSub.unsubscribe();
        this.updateNow();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateNow(): void {
    // Hide the notification first
    this.showUpdateNotification = false;

    // Clear any existing update messages
    this.messageService.clear('update-available');
    this.serviceWorkerService.refresh();
  }

  dismissNotification(): void {
    this.showUpdateNotification = false;
    this.messageService.clear('update-available');
    this.coundDownSub?.unsubscribe();

    // 🔁 Remind user again after 60 seconds
    this.remindUserLater(60);
  }

  private remindUserLater(seconds: number): void {
    setTimeout(() => {
      this.showUpdateNotification = true;
      this.startCountdown();
    }, seconds * 1000);
  }
}